export const validateDateOfBirth = (dobInput: string) => {

  let error = "";
  if(!dobInput)
    return error;

  const minAge = import.meta.env.VITE_APP_MIN_AGE;
  const dob = new Date(dobInput);
  const today = new Date();
  const ageDiff = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  const d = today.getDate() - dob.getDate();

  let age = ageDiff;
  if (m < 0 || (m === 0 && d < 0)) {
    age--; // adjust if birthday hasn't occurred yet this year
  }

  if (dob > today) {
    error = "Incorrect date of birth";
  } else if (age < minAge) {
    error = `You must be at least ${minAge} years old`;
  }

  return error;
};